module.exports = __webpack_public_path__ + "static/media/teacher4.9c53a060.svg";